import {ArchivableItemGQL, ArchivableItemREST, ArchiveRecord} from 'archive/ArchiveConstants';

function getArchiveRecord(item: ArchivableItemREST | ArchivableItemGQL): ArchiveRecord | null {
  if ('archiveRecord' in item) {
    return item.archiveRecord || null;
  } else {
    return null;
  }
}

export default function sortArchivedToLast<T extends ArchivableItemREST | ArchivableItemGQL>(
  items: Array<T>
): Array<T> {
  const notArchivedItems = items.filter((item) => !getArchiveRecord(item));
  const archivedItems = items.filter((item) => Boolean(getArchiveRecord(item)));
  return [...notArchivedItems, ...archivedItems];
}
